import {
  TextureLoader,
  Texture,
  LinearFilter,
  MinificationTextureFilter,
  MagnificationTextureFilter,
} from 'three'
import {BaseLoader} from './BaseLoader'

/**
 * Базовый класс для загрузчиков, использующих текстуры
 * Устраняет дублирование кода загрузки текстур
 */
export abstract class BaseResourceLoader extends BaseLoader {
  protected readonly textureLoader: TextureLoader
  protected loadedResources: Map<string, Texture | null> = new Map()

  constructor(textureLoader?: TextureLoader) {
    super()
    this.textureLoader = textureLoader || new TextureLoader()
  }

  /**
   * Загрузка текстуры с настройками
   */
  protected loadTexture(
    path: string,
    options?: {
      minFilter?: MinificationTextureFilter
      magFilter?: MagnificationTextureFilter
      generateMipmaps?: boolean
      flipY?: boolean
    }
  ): Promise<Texture> {
    return new Promise((resolve, reject) => {
      if (this.loadedResources.has(path)) {
        const texture = this.loadedResources.get(path)
        if (texture) {
          resolve(texture)
          return
        }
      }

      this.textureLoader.load(
        path,
        (texture) => {
          texture.minFilter = options?.minFilter ?? LinearFilter
          texture.magFilter = options?.magFilter ?? LinearFilter
          texture.generateMipmaps = options?.generateMipmaps ?? false
          if (options?.flipY !== undefined) {
            texture.flipY = options.flipY
          }
          this.loadedResources.set(path, texture)
          resolve(texture)
        },
        undefined,
        (error) => {
          console.error(`Failed to load texture: ${path}`, error)
          this.loadedResources.set(path, null)
          reject(error)
        }
      )
    })
  }

  /**
   * Ожидание загрузки ресурса по пути
   */
  protected async waitForResource(path: string): Promise<void> {
    return new Promise((resolve) => {
      const checkResource = setInterval(() => {
        const resource = this.loadedResources.get(path)
        if (resource !== undefined) {
          clearInterval(checkResource)
          resolve()
        }
      }, 100)
    })
  }
}
